import type { FC } from 'react'
import React from 'react'

import type { ArticleProps } from './types'
import Box from '../box/box'

const Article: FC<ArticleProps> = React.forwardRef<
  HTMLDivElement,
  ArticleProps
>(function Article(props, ref) {
  return <Box ref={ref} as="article" {...props} />
})

export default Article
